import Box from "@mui/material/Box";
import { BoxProps, keyframes } from "@mui/system";

const bounce = keyframes`
  0%, 80%, 100% { transform: translateY(0); opacity: 0.35; }
  40% { transform: translateY(-4px); opacity: 1; }
`;

type DotsLoadingProps = {
  size?: number;
  gap?: number;
  color?: string;
  durationMs?: number;
  sx?: BoxProps["sx"];
};

export function DotsLoading({
  size = 6,
  gap = 0.5,
  color = "currentColor",
  durationMs = 900,
  sx,
}: DotsLoadingProps) {
  return (
    <Box
      component='span'
      role='status'
      aria-label='Loading'
      sx={{ display: "inline-flex", alignItems: "center", gap: gap, color, ...sx }}
    >
      {[0, 1, 2].map((i) => (
        <Box
          key={i}
          component='span'
          sx={{
            width: size,
            height: size,
            borderRadius: "50%",
            backgroundColor: "currentColor",
            display: "inline-block",
            animation: `${bounce} ${durationMs}ms infinite ease-in-out`,
            animationDelay: `${i * 120}ms`,
          }}
        />
      ))}
    </Box>
  );
}
